import { render, staticRenderFns } from "./KelengkapanTaksiCard.vue?vue&type=template&id=6cdadc66&"
import script from "./KelengkapanTaksiCard.vue?vue&type=script&lang=js&"
export * from "./KelengkapanTaksiCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports